import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lng]/layout.js\",\"import\":\"Cairo\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/imgs/spiner.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[lng]/_components/common/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[lng]/_components/common/LoadingPage.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/_components/OurLocation.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/globals.css");
